/** Way's own email domain — used to distinguish internal/placeholder brand owners from real ones. */
export const WAY_EMAIL_DOMAIN = 'way.co';

/**
 * True when the email belongs to a Way team member (case-insensitive). A brand owner is treated as an
 * internal placeholder when this is true OR their system role is staff — see the launch-plan owner flow.
 */
export const isWayEmail = (email: string | null | undefined): boolean =>
  !!email && email.trim().toLowerCase().endsWith(`@${WAY_EMAIL_DOMAIN}`);
